// extracted by mini-css-extract-plugin
export default {"block":"TypeBlock-module__block--vj7up","active":"TypeBlock-module__active--g0_3B"};